var _defs, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "master_svg0_1363_71304",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: 0,
    y: 0,
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.7921142578125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_foregroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_foregroundBlur",
    result: "shape"
  })))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#master_svg0_1363_71304)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#000000",
    fillOpacity: 0.6000000238418579
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.37921142578125,
    y: 0.37921142578125,
    width: 23.2415771484375,
    height: 23.2415771484375,
    rx: 11.62078857421875,
    fillOpacity: 0,
    strokeOpacity: 0.10000000149011612,
    stroke: "#FFFFFF",
    fill: "none",
    strokeWidth: 0.7584228515625
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.5,8.5C6.5,8.223857,6.768629,8,7.1,8L15.5,8C15.83138,8,16.1,8.223857,16.1,8.5L16.1,10.75L18.5,9.25L18.5,15L16.1,13.5L16.1,15.5C16.1,15.776150000000001,15.83138,16,15.5,16L7.1,16C6.768629,16,6.5,15.776150000000001,6.5,15.5L6.5,8.5Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.499999940395355,
    cy: 10,
    rx: 0.9999999403953552,
    ry: 1,
    fill: "#3E3F42",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlay);
export default __webpack_public_path__ + "static/media/video_play.29c986ff1632797ff7d3f2d14bd21644.svg";
export { ForwardRef as ReactComponent };